import { render, staticRenderFns } from "./HiddenInputNotificationsComponent.vue?vue&type=template&id=9c3f44da&"
import script from "./HiddenInputNotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./HiddenInputNotificationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports